import React from 'react';
import env from '../../../../env';
import { useGet } from '../../../../components';
import { FootballField } from './footballField';
import { NetballCourt } from './netballCourt';
import { BasketballCourt } from './basketballCourt';
import { CricketGround } from './cricketGround';

export function TeamSelection({ divisionId }) {
  const get = useGet();

  React.useEffect(() => {
    if (divisionId) {
      get.send(env.apiBase + `/api/teamSelection/getPublished?divisionId=${divisionId}`);
    }
    // eslint-disable-next-line
  }, [divisionId]);

  if (!divisionId) return null;
  if (get.loading()) return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
  if (get.hasErrors()) return <div style={{ textAlign: 'center', padding: '40px', color: 'red' }}>Failed to load team selection.</div>;

  const data = get.response;
  if (!data || !data.found) return null;

  let selectionData = { field: [], ruck: [], interchange: [], in: [], out: [] };
  try {
    if (data.selectionData) {
      selectionData = JSON.parse(data.selectionData);
    }
  } catch (e) { /* use defaults */ }

  const sportName = (data.sportName || '').toLowerCase();

  if (sportName === 'football') {
    return (
      <FootballField
        divisionName={data.divisionName}
        gameTitle={data.gameTitle}
        gameDescription={data.gameDescription}
        selectionData={selectionData}
      />
    );
  }

  if (sportName === 'netball') {
    return (
      <NetballCourt
        divisionName={data.divisionName}
        gameTitle={data.gameTitle}
        gameDescription={data.gameDescription}
        selectionData={selectionData}
      />
    );
  }

  if (sportName === 'basketball') {
    return (
      <BasketballCourt
        divisionName={data.divisionName}
        gameTitle={data.gameTitle}
        gameDescription={data.gameDescription}
        selectionData={selectionData}
      />
    );
  }

  if (sportName === 'cricket') {
    return (
      <CricketGround
        divisionName={data.divisionName}
        gameTitle={data.gameTitle}
        gameDescription={data.gameDescription}
        selectionData={selectionData}
      />
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <p>Team selection display for "{data.sportName}" is not yet available.</p>
    </div>
  );
}
